import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneEmpty.styl';

Vue.component('BXmakerAuthuserphoneEmpty',
    {
        template: `
            <div class="bxmaker-authuserphone-empty"  >
               <slot />
            </div>
        `,
    });